var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stu-avatar-info",style:({ width: _vm.widthValue })},[_c('el-avatar',{staticClass:"avatar",attrs:{"src":_vm.headerImg,"size":40}}),_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.usernameValue))]),_c('div',{staticClass:"to-index",on:{"click":_vm.toIndex}},[_c('i',{staticClass:"iconfont"},[_vm._v("")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }